import { locationDeleteApi } from "../../api/location/locationDeleteApi"

type PayloadShape = Parameters<typeof locationDeleteApi>[0]

export async function locationDeleteService(payload: PayloadShape, token: string) {
	return await locationDeleteApi(payload, token)
}
